import { TaxiCorporationListItem } from "../../../../../common/services/taxi-corporation/list/taxi-corporation-list";
import {
  TaxiCorporationUnbilledOrdersListItem,
  TaxiCorporationUnbilledOrdersListItemMissingBillings,
} from "../../../../../common/services/taxi-corporation/unbilled/orders-list/taxi-corporation-unbilled-orders-list";
import BillingsTaxiUnbilledPrivateOrderListingItem, {
  BillingsTaxiUnbilledPrivateOrderListingItemMissingBillingType,
} from "./types/billings-taxi-unbilled-private-order-listing-item";
import BillingsTaxiUnbilledPrivateOrderListingItemStatus from "./types/billings-taxi-unbilled-private-order-listing-item-status";
import BillingsTaxiUnbilledPrivateOrderListingTaxiCorporationSelectOption from "./types/billings-taxi-unbilled-private-order-listing-taxi-corporation-select-option";

const createListingItemStatus = (
  responseDataItem: TaxiCorporationUnbilledOrdersListItem,
): BillingsTaxiUnbilledPrivateOrderListingItemStatus => {
  if (responseDataItem.isCancelled) {
    return BillingsTaxiUnbilledPrivateOrderListingItemStatus.CANCELLED;
  }

  return BillingsTaxiUnbilledPrivateOrderListingItemStatus.FINISHED;
};

const createListingItemMissingBillingTypes = (
  responseItemMissingBillings: TaxiCorporationUnbilledOrdersListItemMissingBillings[],
): BillingsTaxiUnbilledPrivateOrderListingItemMissingBillingType[] => {
  const missingBillingTypes: BillingsTaxiUnbilledPrivateOrderListingItemMissingBillingType[] =
    [];

  if (
    responseItemMissingBillings.includes(
      TaxiCorporationUnbilledOrdersListItemMissingBillings.CARGO_TAXI,
    )
  ) {
    missingBillingTypes.push(
      BillingsTaxiUnbilledPrivateOrderListingItemMissingBillingType.CARGO_WITH_TAXI,
    );
  }

  return missingBillingTypes;
};

const createListingItem = (
  responseDataItem: TaxiCorporationUnbilledOrdersListItem,
): BillingsTaxiUnbilledPrivateOrderListingItem => {
  return {
    clientName: responseDataItem.client.name,
    dispatchName: responseDataItem.dispatch,
    driversDisplayNames: responseDataItem.drivers,
    externalOrderId: responseDataItem.externalId,
    internalOrderId: responseDataItem.humanId,
    passengers: responseDataItem.passengers,
    routeAddresses: responseDataItem.rideAddresses,
    startDate: new Date(responseDataItem.startTime),
    status: createListingItemStatus(responseDataItem),
    taxiCorporations: responseDataItem.taxiCorporations,
    uuid: responseDataItem.uuid,
    missingBillingTypes: createListingItemMissingBillingTypes(
      responseDataItem.missingTaxiBillings,
    ),
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationUnbilledOrdersListItem[],
): BillingsTaxiUnbilledPrivateOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const createTaxiCorporationSelectOption = (
  responseTaxiCorporation: TaxiCorporationListItem,
): BillingsTaxiUnbilledPrivateOrderListingTaxiCorporationSelectOption => {
  return {
    label: responseTaxiCorporation.displayName,
    value: {
      uuid: responseTaxiCorporation.uuid,
      displayName: responseTaxiCorporation.displayName,
    },
  };
};

const createTaxiCorporationSelectOptions = (
  responseTaxiCorporations: TaxiCorporationListItem[],
): BillingsTaxiUnbilledPrivateOrderListingTaxiCorporationSelectOption[] => {
  return responseTaxiCorporations.map(createTaxiCorporationSelectOption);
};

const billingsTaxiUnbilledPrivateOrderListingFactory = {
  createListingItems,
  createTaxiCorporationSelectOptions,
};

export default billingsTaxiUnbilledPrivateOrderListingFactory;
